/**
 * record-id.ts — één definitie van "een geldig record-id" voor invoervalidatie.
 *
 * Vóór de cut waren dat alleen Salesforce-ids (15/18 tekens). Onder de
 * cut-schakelaar munt de app eigen ids (`eigen-<uuid>`, zie sf-sync-kopie.ts),
 * en de cut-repetitie van 05-09 liet zien dat 60+ endpoints die met een
 * inline regex weigerden ("Ongeldig invoiceId") — een factuur was aan te
 * maken maar daarna niet meer te openen, te wijzigen of te crediteren.
 *
 * Gebruik dit voor alles wat een id van de client accepteert. Niet voor
 * regexes die iets anders doen (pad-classificatie in de teller, 15/18-
 * vergelijking in de schaduw, id uit een foutmelding vissen).
 */
export const RECORD_ID_RE =
  /^(?:[a-zA-Z0-9]{15,18}|eigen-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/;

export function isRecordId(v: unknown): v is string {
  return typeof v === 'string' && RECORD_ID_RE.test(v);
}
